import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { checkChanges } from '../../utils/checkChanges';

import Edit from './Edit';

export default class Video extends Component {
  static propTypes = {
    children: PropTypes.node,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Edit = checkChanges(Edit)

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: true,
      data: null,
    };
  }
  componentDidMount() {
    this.fetchMedia();
  }
  componentWillReceiveProps(nextProps) {
    const { id } = nextProps.params;
    if (id !== this.props.params.id) {
      this.fetchMedia();
    }
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchMedia() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/medias/${this.props.params.id}/?oembed=true`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      // handle token.. etc
      const token = res.headers.get('X-Csrf-Token');
      await this.setComponentState({
        data,
        token,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        loading: this.state.loading,
        data: this.state.data,
        id: this.props.params.id,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Video/Video.jsx